import { render, staticRenderFns } from "./Lint.vue?vue&type=template&id=b4937676"
import script from "./Lint.vue?vue&type=script&lang=js"
export * from "./Lint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports